import { useSelector } from 'react-redux';

// Top bar renders only when enabled AND it has something to show
const useTopBarVisible = () => {
  const topBar = useSelector((state) => state.template?.topBar);
  const socials = useSelector((state) => state.template?.socialMedia);
  const hasText = !!(topBar?.leftSectionText?.trim() || topBar?.middleSectionText?.trim());
  const hasAnySocial = !!(socials?.facebook || socials?.instagram || socials?.x || socials?.linkedIn || socials?.tikTok);
  return !!topBar?.showTopBar && (hasText || hasAnySocial);
};

export default useTopBarVisible;
